import React, { ReactNode, ForwardRefExoticComponent } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import type { XHComponentCommonProps } from "../../types";

import Steps from "./Steps";
import "./index.scss";

export type StepProps = {
  icon?: string | ReactNode;
  title: string | ReactNode;
  description?: string | ReactNode;
  direction?: "horizontal" | "vertical";
  status?: "wait" | "process" | "finish" | "error";
  fancy?: boolean;
  dashed?: boolean;
  style?: React.CSSProperties;
  prefix?: ReactNode;
  dataTrackId?: string;
} & XHComponentCommonProps;

const classPrefix = "xh-step";

const Step: React.FC<StepProps> = props => {
  const {
    title,
    description,
    icon,
    status = "wait",
    fancy,
    style,
    className,
    direction,
    prefix,
    dashed,
    dataTrackId,
  } = props;

  return (
    <View
      className={classNames(
        `${classPrefix}`,
        `${classPrefix}-status-${status}`,
        className
      )}
      data-track-id={dataTrackId}
      style={style}
    >
      {direction === "vertical" && prefix && (
        <View className={`${classPrefix}-prefix`}>{prefix}</View>
      )}
      <View className={classNames(`${classPrefix}-indicator`, { dashed })}>
        <View
          className={classNames(`${classPrefix}-icon-container`, { fancy })}
        >
          {icon}
        </View>
      </View>
      <View className={`${classPrefix}-content`}>
        <View className={`${classPrefix}-title`}>{title}</View>
        {!!description && (
          <View className={`${classPrefix}-description`}>{description}</View>
        )}
      </View>
    </View>
  );
};

export type HybridComponent = ForwardRefExoticComponent<StepProps> & {
  Steps: typeof Steps;
};

const XHStep = Step as HybridComponent;
XHStep.Steps = Steps;

export default XHStep;
